module.exports = __webpack_public_path__ + "img/shaka.eac63a86.svg";